import { Box } from "@mui/material";
import {
  ProcessingSong,
  StyledCardMedia,
  StyledCardMediaMyTrack,
} from "../styles";
import { ArtWorkProps } from "../types";
import { ENTERPRISE_ARTWORK_TEMPLATE, isEnterprise } from "../../../theme";
import { useEffect, useState } from "react";
import { getThumbnailUrl } from "../../../utils/thumbnailUtil";

export const ArtWork: React.FC<ArtWorkProps> = ({
  isProcessing,
  expand,
  image,
}) => {

  const [artworkImage, setArtworkImage] = useState<string| undefined>();

  useEffect(() => {
    const helper = async () => {
      if (image && image !== "") {
        const thumbnailUrl = await getThumbnailUrl(image);
        setArtworkImage(thumbnailUrl);
      }else {
        setArtworkImage(image)
      }
    };
    helper();
  }, [image]);
  
  return (
    <Box>
      {isProcessing ? (
        <ProcessingSong
          image={
            artworkImage?.includes("http")
              ? artworkImage
              : isEnterprise
              ? ENTERPRISE_ARTWORK_TEMPLATE
              : "/assets/images/logo512.png"
          }
        />
      ) : expand ? (
        <StyledCardMedia
          image={
            artworkImage && artworkImage.includes("http")
              ? artworkImage
              : isEnterprise
              ? ENTERPRISE_ARTWORK_TEMPLATE
              : "/assets/images/logo512.png"
          }
        />
      ) : (
        <StyledCardMediaMyTrack
          image={
            artworkImage && artworkImage.includes("http")
              ? artworkImage
              : isEnterprise
              ? ENTERPRISE_ARTWORK_TEMPLATE
              : "/assets/images/logo512.png"
          }
        />
      )}
    </Box>
  );
};
